const components = {
    MuiStepConnector: {
        styleOverrides: {
            root: {
                '&.Mui-disabled': {
                    '.MuiStepConnector-line': {
                        border: '3px solid #EB1722',
                        borderRadius: '4px',
                    },
                },
                '&.Mui-active': {
                    '.MuiStepConnector-line': {
                        border: '3px solid',
                        borderRadius: '4px',
                    },
                },
                '&.Mui-completed': {
                    '.MuiStepConnector-line': {
                        border: '3px solid',
                        borderRadius: '4px',
                    },
                },
            },
        },
    },
    MuiStepLabel: {
        styleOverrides: {
            label: {
                fontFamily: 'Archivo, sans-serif', // Change the font for MuiStepLabel
                fontWeight: '700'
            },
            root: {
                '&.Mui-disabled': {
                    '.MuiSvgIcon-root': {
                        color: '#ffb6b9',

                        '.MuiStepIcon-text': {
                            color: '#fff',
                        }
                    }
                },
            }
        }
    },
    MuiStepIcon: {
        styleOverrides: {
            root: {
                width: 36, // Set the width of the circle
                height: 36, // Set the height of the circle
            },
            // text: {
            //     fill: 'white', // Change the color of the number inside the circle
            // },
        },
    },
    MuiButton: {
        styleOverrides: {
            root: {
                borderRadius: 30,
            }
        },
        variants: [
            {
                props: {variant: 'contained'},
                style: {
                    textTransform: 'none',
                    border: 'none',
                    background: '#ef3239',
                    color: '#fff',
                    padding: '12px 16px',
                    gap: '10px',
                    '&:hover': {
                        background: '#e82f38',
                    },
                    '&:active': {
                        background: '#EB1722'
                    }
                },
            }, {
                props: {variant: 'outlined'},
                style: {
                    textTransform: 'none',
                    border: '2px solid #EB1722',
                    background: 'transparent',
                    color: '#EB1722',
                    padding: '12px',
                    gap: '8px',
                    '&:hover': {
                        background: '#ffdbdf',
                        border: '2px solid #EB1722',
                    },
                    '&:active': {
                        background: '#fda5a9',
                        border: '2px solid #EB1722',
                    }
                },
            }, {
                props: {variant: 'text'},
                style: {
                    textTransform: 'none',
                    border: 'none',
                    background: 'transparent',
                    color: '#EB1722',
                    padding: '12px',
                    gap: '8px',
                    '&:hover': {
                        background: '#ffd2d5',
                    },
                    '&:active': {
                        background: '#ffadb1',
                    }
                },
            },
        ],
    },
    MuiInputBase: {
        styleOverrides: {
            root: {
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 2,
                paddingBottom: 2,
                borderRadius: 20,
                backgroundColor: '#F3F5F7',
                transition: 'background .4s ease'
            }
        }
    },
    MuiInput: {
        styleOverrides: {
            root: {
                '&:before': {
                    content: 'none',
                },
                '&:after': {
                    content: 'none',
                },
                '&:hover': {
                    content: 'none',
                },
                '&.Mui-error': {
                    background: '#ffbaba',
                    transition: 'background .4s ease'
                },
            }
        }
    },
    MuiFormHelperText: {
        styleOverrides: {
            root: {
                // Add your font definition for helper text here
                fontFamily: 'Archivo, sans-serif',
                textTransform: 'none',
                paddingLeft: 10
                // fontSize: 14,
                // color: '#616161', // Choose your desired color
            },
        },
    },
    MuiDataGrid: {
        styleOverrides: {
            root: {
                border: '1px solid #F3F3F1',
                background: '#fff',
                borderRadius: '16px'
            },
            cell: {
                border: 'none'
            },
        }
    },
    MuiCalendarPicker: {
        styleOverrides: {
            root: {
                border: '1px solid #EFF8F3',
                borderRadius: '16px'
            },
        },
    },
    // MuiPickersDay: {
    //     styleOverrides: {
    //         root: {
    //             border: '1px solid #EFF8F3',
    //             borderRadius: '16px',
    //             "&.Mui-selected !important": {
    //                 "backgroundColor": "red"
    //             },
    //             "&.Mui-disabled": {
    //                 "backgroundColor": "red"
    //             },
    //             "not(.Mui-disabled)": {
    //                 "backgroundColor": "red"
    //             }
    //         },
    //
    //     },
    // },
}

export {components}